export const single = {
  "stuk": "stuk",
  "hoop": "hoop",
  "hoop(4x)": "hoop(4x)",
  "hoop(8x)": "hoop(8x)",
  "1/2hand": "1/2hand",
  "takjes(4x)": "takjes(4x)",
  "bosje": "bosje",
  "pakje": "pakje",
}

export const multiple = {
"stuk": "stukken",
  "hoop": "hopen",
  "hoop(4x)": "hoopjes(4x)",
  "hoop(8x)": "hoopjes(8x)",
  "1/2hand": "1/2hand",
  "takjes(4x)": "takjes(4x)",
  "bosje": "bosjes",
  "pakje": "pakjes",
}